<template>
  <div id="wrap" class="android">
    <div class="android_header">
      <h1><img src="@/assets/image/install/icon-app-kolonapps@2x.png" alt=""></h1>
      <p class="title_1">KOLON의 앱스토어</p>
      <h1><img src="@/assets/image/install/img-ka-logo@2x.png" alt=""></h1>
      <p class="title_2">KOLON Apps 앱을 설치해 주세요.</p>
      <a :href="installUrl" @click="checkDevice($event)">설치</a>

    </div>
    <div class="android_cont">
      <div style="background-color: #efefef;">
        <h1><img src="@/assets/image/install/main@2x.gif" alt="" style="width:82%"></h1>

        <p v-if="plfTpNm == 'android'" class="android_suggest">
          <i><img src="@/assets/image/install/chrome.png"></i>크롬
          <i><img src="@/assets/image/install/browser.png"></i>인터넷 브라우저 앱을 권장합니다.
        </p>
        <p v-if="plfTpNm == 'android'" class="android_min_ver" >
          ※ OS 최소 지원버전: Android 12<br>
          (앱마다 조금의 차이는 있을 수 있습니다.)
        </p>
        <p v-if="plfTpNm == 'ios'" class="android_min_ver">
          ※ OS 최소 지원버전: iOS16.6<br>
          (앱마다 조금의 차이는 있을 수 있습니다.)
        </p>
      </div>

      <div class="android_need_help">
        <p>
          모바일 앱 사용에 어려움이 있으신가요?
        </p>
      </div>

      <!-- 설치 FAQ -->
      <faq-list-view class="android_faq" v-if="faqInstallList !=null && faqInstallList.length !== 0"
                     :list="faqInstallList" :title="'설치가 안돼요'" :accordionId="1"></faq-list-view>
      <!-- 사용 FAQ -->
      <faq-list-view class="android_faq" v-if="faqUseList !=null && faqUseList.length !== 0"
                     :list="faqUseList" style="margin-top: 92px;" :title="'사용이 안돼요'" :accordionId="2"></faq-list-view>

    </div>
  </div>
</template>

<style scoped>
@import "../assets/css/install.css";
.android_header a{
  text-decoration: none;
}
</style>

<script>
import Util from "@/util/Util";
import axios from "axios";
import FaqListView from "@/views/FaqListView";

export default {
  name: 'Home',
  components: {
    FaqListView
  },
  data(){
    return {
      plfTpNm: 'android',
      faqAllList: [],
      faqInstallList: [],
      faqUseList: [],
    }
  },
  computed: {
    installUrl() {
      if(Util.isIOS()){
        // https://appdev.kolon.com/common/v2/api/
        return `itms-services://?action=download-manifest&url=${process.env.COMN_URL}app/downByLatestOfAll/142`
      } else{
        return `${process.env.COMN_URL}app/downByLatestOfAll/143`
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (Util.isIOS()) {
        this.plfTpNm = 'ios'
      } else {
        this.plfTpNm = 'android'
      }
      this.getList()
    },
    getList() {
      axios({
        method: "get",
        url: process.env.WEBS_URL + `/faq/list?plfTpNm=${this.plfTpNm}`,
        headers: {
          "Content-Type": "application/json",
        }
      }).then(res => {
        this.faqAllList = res.data.data

        this.faqInstallList = this.faqAllList.filter(item => item.type === 'INSTALL')
        this.faqInstallList.sort(function(a, b) { // 우선 순위 정렬.
          return a.prr - b.prr;
        });

        this.faqUseList = this.faqAllList.filter(item => item.type === 'USE')
        this.faqUseList.sort(function(a, b) { // 우선순위 정렬.
          return a.prr - b.prr;
        });

        for (const item of this.faqInstallList) {
          this.getOneItem(item)
        }
        for (const item of this.faqUseList) {
          this.getOneItem(item)
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    getOneItem(item) {
      axios({
        method: "get",
        url: process.env.WEBS_URL + `/faq/item/${item.id}`,
        headers: {
          "Content-Type": "application/json",
        }
      }).then(res => {
        item.appFaqSubs = res.data.data.appFaqSubs
      }).catch(function (error) {
        console.log(error)
      })
    },
    checkDevice(event) {
      // 260324 CO00118910 jihwan_choi1  Mac(PC) 사용자 대상 앱 다운로드 제한
      // Mac이 아니면 preventDefault가 호출되지 않으므로 href에 적힌 URL로 자연스럽게 이동합니다.
      if (Util.isIOSMac()) {
        // 1. 안내 메시지 출력
        alert("지원하지 않는 기기입니다.");
        // 2. href 링크 이동을 강제로 취소 (핵심!)
        event.preventDefault();
      }

    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue